import { Component } from "react";

import './card.styles.css'

class Card extends Component{
    
     render(){
        const {id,email,name} = this.props.monster;
        console.log(this.props);
        return(
            
                <div className="card-container" key={id}>
                <img alt={`monster ${name}`} src={`https://robohash.org/${id}?set=set2&size=180x180`}/>
                <h2>{name}</h2>
                <a href={`mailto:${email}`}>{email}</a>
                </div>
        )
            
        
    }
}

export default Card;